// Page file structure (wrapper):
import { MenuManagement } from '../../components/Admin/Menu_Management';
import AdminLayout from '../../components/Admin/Layout/AdminLayout';

export default function MenuManagementPage() {
  return (
    <AdminLayout>
      <MenuManagement />  {/* Uses the component */}
    </AdminLayout>
  );
}